(function () {
  var header = document.querySelector('[data-cellfy-header][data-sticky]');
  if (!header) return;

  var pageWrapper = document.querySelector('.page-wrapper');
  var THRESHOLD = 2;

  function getScrollY() {
    // Em telas largas (≥990px) o tema rola dentro de .page-wrapper
    // (overflow-y:auto), não na janela — por isso checamos os dois.
    var wrapperScroll = pageWrapper ? pageWrapper.scrollTop : 0;
    return wrapperScroll || window.scrollY || document.documentElement.scrollTop;
  }

  function update() {
    // Altura real do header (72px desktop, 60px mobile) — usado pelo
    // espaçador que evita o conteúdo "pular" quando o header vira fixed.
    document.documentElement.style.setProperty('--cellfy-header-height', header.offsetHeight + 'px');

    if (getScrollY() > THRESHOLD) {
      header.setAttribute('data-scrolled', '');
    } else {
      header.removeAttribute('data-scrolled');
    }

    // O modal de "minha conta" (componente nativo <shopify-account>) lê
    // --account-offset-top pra saber onde abrir. Essa variável era definida
    // só dentro de ".header" (a estrutura nativa que substituímos) — nunca
    // chegava até o nosso header customizado, então o modal sempre abria
    // no topo da página. Calculamos aqui com a altura real do header atual.
    var offset = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--account-offset-top', offset + 'px');
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', update, { passive: true });
  }
})();

/* CELLFY: sino de alertas — para de "pular" (animação em header.liquid)
   assim que o cliente clica. Guarda em sessionStorage pra continuar
   parado ao navegar pra outras páginas na mesma visita (some de novo
   só numa sessão nova). IIFE separada de propósito — o sino existe
   mesmo em headers sem data-sticky, então não depende do early-return
   lá em cima. */
(function () {
  var STORAGE_KEY = 'cellfyAlertsSeen';
  var trigger = document.querySelector('[data-cellfy-alerts-trigger]');
  if (!trigger) return;

  if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
    trigger.setAttribute('data-cellfy-alerts-seen', '');
  }

  trigger.addEventListener('click', function () {
    trigger.setAttribute('data-cellfy-alerts-seen', '');
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // sessionStorage indisponível (modo privado, etc.) — a animação
      // só para nessa página, sem persistir entre navegações.
    }
  });
})();